exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.anniversary-notification[data-v-bd555022] {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n@media screen and (min-width: 896px) {\n.anniversary-notification[data-v-bd555022] {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    max-width: 1120px;\n    min-height: 96px;\n}\n}\n@media screen and (max-width: 895px) {\n.anniversary-notification[data-v-bd555022] {\n    margin-bottom: 0;\n}\n}\n", ""]);

// exports
